module.exports = __webpack_public_path__ + "static/media/character.cb107198.png";